export default "__VITE_ASSET__CPEUqXLK__"